import {combineReducers} from "redux";
import leapSale from "./leapSale";
import paging from "./paging";
import filter from "./filter";


const leapBettingReducer = combineReducers({
    leapSale,
    paging,
    filter
});
export default leapBettingReducer;